export const VectorUpIcon = () => {
    return (
        <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 0.666748L15.5 8.66675H-0.5L7.5 0.666748Z" fill="currentColor" />
        </svg>
    );
};
